import React from "react";
import {
    Box,
    VStack,
    HStack,
    Center,
    Heading,
    Text,
    Flex,
    Stack,
    Link,
    Button,
    useColorModeValue,
    theme,
    Grid,
} from "@chakra-ui/react";
import { getList } from "controllers/bookmark";
import Tweets from "components/tweets";
import { CustomHead } from "components/custom-head";

import { useSession } from "next-auth/client";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import {XYPlot, LineSeries} from 'react-vis';
import Tweet from "components/tweets/masonry/tweet";

function Trend({ topic, index, maxFreqTime, maxLikeTime }) {

    const [isCollapse, setIsCollapse] = React.useState(true);
    const isAuthenticated = useFirebaseUser();
    const [refresh, refresher] = React.useState({});

    // console.log(topic?.tweets?.length);
    // console.log(isCollapse);
    // console.log(isCollapse ? topic?.tweets?.slice(0, 3) : topic?.tweets);

    return (
        <Flex key={"topic-"+index} flexDir="column" maxWidth="1000px">
            <Flex flexDir={{base: "column", md: "row"}} justifyContent={{base: "flex-start", md: "space-between"}}>
                <Flex flexDirection="column">
                    <Heading as="h2" fontSize="2xl">
                        {/* {topic.topic.replace(/\s\|\s/g, ", ")} */}
                        {topic.topicFormatted ?? topic.topic.replace(/\s\|\s/g, ", ")}
                    </Heading>
                    <Text ml={0} mt={0} fontSize="sm" color="gray.400">({topic.topic.replace(/\s\|\s/g, ", ")})</Text>
                </Flex>
                {
                    // topic.likeTime?.length > 0 && (
                    topic.freqTime?.length > 0 && (
                        <Flex h={{base: "100px", md: "50px"}} mt={0} justifyContent="center" alignItems="center" flexDir="column">
                            <Box ml="-40px" mt="40px">
                                <XYPlot height={100} width={350}>
                                    <LineSeries curve={'curveMonotoneX'} data={topic.likeTime.map((x, index) => {
                                    // <LineSeries yDomain={[0, maxLikeTime]} curve={'curveMonotoneX'} data={topic.freqTime.map((x, index) => {
                                            return {
                                                x: index,
                                                y: x
                                            }
                                        })} />
                                    <Box position="absolute" top="22px" left="-120px" w="300px" h="1px" p="0" m="0" borderTop={"solid 1px " + theme.colors.gray[100]}></Box>
                                </XYPlot>
                            </Box>
                            {/* {
                                (!process?.env?.NODE_ENV || process.env.NODE_ENV === 'development') && (
                                    <Box ml="-40px" mt="-40px">
                                        <XYPlot height={100} width={350}>
                                            <LineSeries yDomain={[0, maxLikeTime]} curve={'curveMonotoneX'} data={topic.freqTime.map((x, index) => {
                                                    return {
                                                        x: index,
                                                        y: x
                                                    }
                                                })} />
                                            <Box position="absolute" top="22px" left="-120px" w="300px" h="1px" p="0" m="0" borderTop={"solid 1px " + theme.colors.gray[100]}></Box>
                                        </XYPlot>
                                    </Box>
                                )
                            } */}
                        </Flex>
                    )
                }
            </Flex>
            <Text mt={2} color="gray.400"><i>Best tweets on this topic</i></Text>
            <Box>
                {
                    isCollapse ? (
                        // <Tweets
                        //     key={"collapse-tweets-"+index}
                        //     savedTweet={[]}
                        //     tweets={topic?.tweets?.slice(0, 3)}
                        //     // tweets={topic?.tweets}
                        //     disableBlur={true}
                        //     disableBookmarkButton={true}
                        //     disableRequest={!isAuthenticated}
                        //     disableHideButton={true}
                        //     disableEmbed={true}
                        //     disableEditTweet={true}
                        //     disableSaveCsv={true}
                        //     refresher={refresher}
                        //     refresh={refresh}
                        //     forceDisplayName={true}
                        // />
                        <HStack
                            flexDir={{base: "column", lg: "row"}}
                            spacing={{base: 0, lg: 3}}
                            alignItems="flex-start"
                            mt={2}
                        >
                            {
                                topic?.tweets?.slice(0, 3)?.map((tweet, index) => (
                                    <Box w={{base: "100%", lg: "400px"}} pt={{base: "2", lg: "0"}} >
                                        <Tweet
                                            key={"collapse-tweets-"+topic.topic+index}
                                            savedTweet={[]}
                                            tweet={{data: tweet}}
                                            disableBookmarkButton={true}
                                            disableRequest={!isAuthenticated}
                                            disableHideButton={true}
                                            disableEditTweet={true}
                                            forceDisplayName={true}
                                        />
                                    </Box>
                                ))
                            }
                        </HStack>
                    ) : (
                        <Tweets
                            key={"tweets-"+index}
                            savedTweet={[]}
                            tweets={topic?.tweets}
                            // tweets={topic?.tweets}
                            disableBlur={true}
                            disableBookmarkButton={true}
                            disableRequest={!isAuthenticated}
                            disableHideButton={true}
                            disableEmbed={true}
                            disableEditTweet={true}
                            disableSaveCsv={true}
                            refresher={refresher}
                            refresh={refresh}
                            forceDisplayName={true}
                        />
                    )
                }
            </Box>
            {
                topic?.tweets?.length > 3 && (
                    <Flex mt={5} mb={5} w="100%" justifyContent="flex-end">
                        {/* <Button variant="tertiary" onClick={(e) => {setIsCollapse(!isCollapse); refresher({});}}>
                            {isCollapse ? "See more..." : "Collapse"}
                        </Button> */}
                        <Button as={Link} variant="tertiaryNoBackground" href={"/trending/" + topic.topicWord} >
                            {isCollapse ? "See more..." : "Collapse"}
                        </Button>
                    </Flex>
                )
            }
        </Flex>
    );
}

// export default function Post() {
export function TrendList({ topics, isQueryEmbeding=false }) {

    const [session, loading] = useSession();

    if (topics.some(x => x.freqTime?.length > 0) && topics.some(x => x.likeTime?.length > 0)) {
        var maxFreqTime = Math.max(...topics?.map(x => Math.max(...x.freqTime)));
        var maxLikeTime = Math.max(...topics?.map(x => Math.max(...x.likeTime)));
        console.log("maxFreqTime: ", maxFreqTime);
        console.log("maxLikeTime: ", maxLikeTime);
        console.log("nb topics: ", topics?.length);
    }

    return (
        <Stack spacing={10} p={{base: 2, md: 10}}> 
            {
                topics?.map((topic, index) => (
                    <Trend key={index} topic={topic} index={index} maxLikeTime={maxLikeTime} maxFreqTime={maxFreqTime} />
                ))
            }
        </Stack>
    );
}